import { useEffect } from "react";

export const useOutsideClick = (ref, callback) => {
  const handleClick = e => {
    if (Array.isArray(ref)) {
      let willBeCalled = true;

      for (let i = 0, rLen = ref.length; i < rLen; i++) {
        if (!e.target.parentNode || (ref[i].current && ref[i].current.contains(e.target))) {
          willBeCalled = false;
        }
      }
      if (willBeCalled) {
        callback();
      }
    } else {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};
